import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-700 font-bold text-xl" }, "얼굴 매핑", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 text-sm tracking-wider self-baseline ml-2" }, " *오른쪽 이미지 중 변환할 얼굴을 선택해주세요. ", -1)
const _hoisted_3 = ["src"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RightOutlined = _resolveComponent("RightOutlined")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, null, {
    title: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    default: _withCtx(() => [
      (_ctx.faceList.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList((_ctx.faceList as string[]), (face, findex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: findex,
              class: _normalizeClass(["flex gap-4 items-center", { 'mt-2': findex !== 0 }])
            }, [
              _createElementVNode("img", {
                src: face,
                alt: "targetFace",
                class: "w-32 h-32 transition-all cursor-pointer"
              }, null, 8, _hoisted_3),
              _createVNode(_component_RightOutlined, {
                style: {"color":"black"},
                class: "text-xl mx-4"
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetFaces, (target, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  style: _normalizeStyle([{"border":"1px solid #d9d9d9"}, _ctx.selectedIndex === index ? 'border: 3px solid #ff7875' : '']),
                  class: "transition-all cursor-pointer overflow-hidden",
                  onClick: ($event: any) => (_ctx.onSelect(index))
                }, [
                  _createElementVNode("img", {
                    class: "w-32 h-32",
                    src: target.url
                  }, null, 8, _hoisted_5)
                ], 12, _hoisted_4))
              }), 128))
            ], 2))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}